<div class="h-100 w-100 ">
    <div class="vehicle-profile-header widget-title">{{widgetData?.title}}</div>
    <app-linear-gauge [linearGaugeData]="linearGaugeData"></app-linear-gauge>
    <div class="mt-10 status-legend">
        <div class="status-dot red"></div>
        <span>Offline</span>
        <div class="status-dot green ml-2"></div>
        <span>Online</span>
    </div>
</div>